import { useFormState } from './useFormState';

export const useFormActions = <FormValuesT, >() => {
  const { actions } = useFormState<FormValuesT>();
  return actions;
};
